import * as THREE from 'three';
import { EYE_HEIGHT } from '../player';

export const TAKASE_EYE_HEIGHT = EYE_HEIGHT + .02;

/** Fit a detached model using the actual eye joints, keeping feet on the floor.
 * Hair volume must not make the face sink below the player's eyes.
 */
export function fitTakaseEyeLevel(root: THREE.Object3D): number {
  if (root.parent) throw new Error('Character fitting requires a detached root');
  root.updateMatrixWorld(true);
  const bounds = new THREE.Box3().setFromObject(root);
  const eyes = ['eye.L', 'eye.R'].map(name =>
    root.getObjectByName(THREE.PropertyBinding.sanitizeNodeName(name)) ?? root.getObjectByName(name));
  if (eyes.some(eye => !eye)) throw new Error('Missing eye joints');
  const eyeY = eyes.reduce((sum, eye) => sum + eye!.getWorldPosition(new THREE.Vector3()).y, 0) / 2;
  const height = eyeY - bounds.min.y;
  if (!Number.isFinite(height) || height <= 0 || bounds.isEmpty()) throw new Error('Invalid eye height');
  const factor = TAKASE_EYE_HEIGHT / height;
  const position = root.position.clone().multiplyScalar(factor);
  const center = bounds.getCenter(new THREE.Vector3());
  root.scale.multiplyScalar(factor);
  root.position.set(position.x - center.x * factor, position.y - bounds.min.y * factor,
    position.z - center.z * factor);
  root.updateMatrixWorld(true);
  return (bounds.max.y - bounds.min.y) * factor;
}
